export default "__VITE_ASSET__CnTvTbVP__"